import moment from 'moment';
import { Types } from '../actions/externalSystemActions';


const initialState = {
    filterModel: {
        StartDate: moment()
            .startOf('day')
            .add(-7, 'days')
            .add(12, 'hours')
            .format('YYYY-MM-DD'),
        EndDate: moment().format('YYYY-MM-DD'),
        ChannelId: null,
        IssueType: null
    },
    result: {
        data: [],
        errorDetails: null
    },
    isLoading: false,
}

export const externalSystemReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_EXTERNAL_SYSTEM_DATAS_RESPONSE: {
            return {
                ...state,
                result: action.payload
            }
        }

        case Types.SET_EXTERNAL_SYSTEM_REQUEST_STATUS: {
            return {
                ...state,
                isLoading: action.payload
            }
        }

        case Types.SET_EXTERNAL_SYSTEM_REQUEST_FILTER: {
            const { name, value } = action.payload;
            return {
                ...state,
                filterModel: {
                    ...state.filterModel,
                    [name]: value
                }
            }
        }

        default:
            return state;
    }
}